//#region src/orders_api_version.ts
var OrdersApiVersion = /* @__PURE__ */ function(OrdersApiVersion) {
	OrdersApiVersion["V1"] = "V1";
	OrdersApiVersion["V2"] = "V2";
	OrdersApiVersion["V3"] = "V3";
	return OrdersApiVersion;
}(OrdersApiVersion || {});
//#endregion
export { OrdersApiVersion };

//# sourceMappingURL=orders_api_version.js.map